import { styled } from "@mui/styles";
import Card from "@mui/material/Card";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const StyledCard = styled(Card)({
    '& .MuiCardContent-root:last-child': {
        paddingBottom: '16px'
    },
    '& .MuiCardContent-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '15px',
    }
});

const useStyles = makeStyles(() =>
    createStyles({
        amount: {
            fontSize: '28px !important', 
            lineHeight: '33px !important', 
            fontWeight: '600 !important'
        }
    }),
);

export default useStyles;